import type { Address } from '@mend/types/address';

import { useQuery } from '@tanstack/react-query';

import { AddressesAutocomplete } from '#components/Autocomplete/AddressesAutocomplete.tsx';
import { me } from '#lib/react-query/queries.ts';
import { useFilterAutocomplete } from './use-filter-autocomplete';

const defaultProps = {
  inputLabel: 'Location',
  inputSize: 'medium',
} as const;

export function Address(props: { defaultValue: Address['id'][] }) {
  const query = useQuery(me);

  const filterAutocomplete = useFilterAutocomplete({
    searchParamKey: 'aId',
    defaultValue: props.defaultValue,
    data: query.data?.org.addresses,
  });

  if (query.isLoading) {
    return <AddressesAutocomplete {...defaultProps} value={null} disabled />;
  }

  return <AddressesAutocomplete {...defaultProps} {...filterAutocomplete.getAutocompleteProps()} />;
}
